import '../components/test.css'
import Assesment from '../components/mentor/assesment'
import Mentor from '../components/mentor/mentor'

function AddAssesment() {
 

  return (
    <div className='newAdmin'>  
      <Assesment/>
    </div>
  )
}

export default AddAssesment
